var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutAuth',{attrs:{"validation-errors":_vm.validationErrors},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Login ")]},proxy:true}])},[_c('Login',{on:{"validationErrors":_vm.handleValidationErrors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }